function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 3.5v-1a2 2 0 0 0-2-2h-5a2.025 2.025 0 0 0-2 2v1h-5v1h1l1.01 19.036A2.131 2.131 0 0 0 4.605 25.5h10.79a2.131 2.131 0 0 0 2.095-1.964L18.5 4.5h1v-1h-5zm-2-2a1 1 0 0 1 1 1v1h-7v-1a1 1 0 0 1 1-1h5zm3.995 21.97a1.135 1.135 0 0 1-1.1 1.03H4.605a1.135 1.135 0 0 1-1.1-1.03L2.5 4.5h15l-1.005 18.97zM10.5 22.5v-16h-1v16h1zm-3 0l-1-16h-1l1 16h1zm6.995-16h-1.02l-.975 16h1l.995-16z",
  fill: "#414B80",
  fillRule: "nonzero"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.ad663d56.svg";
export { ForwardRef as ReactComponent };